import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, InputWithLabel, Link, Text } from '@reveni-io/reveni-ui'

import { externalGateways } from '@/common/constants'
import AppContext from '@/common/context/app.context'

import StripeSettings from './StripeSettings/StripeSettings'
import { settingsFormFields } from './constants'
import * as Styles from './styles'

const IntegrationSettings = ({ integration, onChange }) => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const configuration = integration?.configuration
  const readOnly = integration?.read_only
  const isStripeConnected = info?.billing_data?.external_connected_gateway === externalGateways.stripe
  const shouldShowWebhookAlert = configuration && Object.keys(configuration).includes('token')
  const integrationsWithoutConfiguration = ['stripe']

  if (
    readOnly ||
    !configuration ||
    (Object.keys(configuration)?.length === 0 && !integrationsWithoutConfiguration.includes(integration?.type))
  )
    return (
      <Alert type="info">
        {t('Esta es una integración personalizada. Si necesitas cambiar su configuración, ponte en contacto con')}{' '}
        <Link href="mailto:merchants@reveni.io">merchants@reveni.io.</Link>
      </Alert>
    )

  return (
    <Styles.Container>
      <Text type="titleS">{t('Configuración')}</Text>
      {integration?.type === externalGateways.stripe && <StripeSettings isConnected={isStripeConnected} />}
      {Object.entries(configuration).map(([key, config]) => {
        const field = settingsFormFields[key] || {}

        return (
          <InputWithLabel
            key={key}
            label={t(field.label)}
            value={config.value || ''}
            onChange={e => onChange(key, e.target.value)}
            type={field.type}
            helperText={t(field.helperText)}
          />
        )
      })}
      {shouldShowWebhookAlert && (
        <Alert type="info">
          <Text type="bodyMBold" tag="span">
            Webhook:
          </Text>{' '}
          {t('Las validaciones deben enviarse a la siguiente URL:')}{' '}
          <Text type="bodyMBold" tag="span">
            https://platforms.reveni.io/integrations/modexpress/webhooks/validation
          </Text>
        </Alert>
      )}
      {integration?.type === externalGateways.primer && (
        <Alert type="info">
          <Text type="bodyMBold" tag="span">
            Webhook:
          </Text>{' '}
          {t('Las validaciones deben enviarse a la siguiente URL:')}{' '}
          <Text type="bodyMBold" tag="span">
            https://platforms.reveni.io/gateways/primer/webhook/
          </Text>
        </Alert>
      )}
    </Styles.Container>
  )
}
export default IntegrationSettings
